/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestReq1
 */
export interface TestReq1 {
    /**
     * 平台字典ID。
     * @type {number}
     * @memberof TestReq1
     */
    businessPlatformId: number;
    /**
     * 平台侧企业/店铺账号标识。
     * @type {string}
     * @memberof TestReq1
     */
    externalAccountId: string;
    /**
     * 待测试Key明文，不落库。
     * @type {string}
     * @memberof TestReq1
     */
    credentialKey: string;
    /**
     * 待测试Secret明文，不落库。
     * @type {string}
     * @memberof TestReq1
     */
    credentialSecret: string;
}

/**
 * Check if a given object implements the TestReq1 interface.
 */
export function instanceOfTestReq1(value: object): value is TestReq1 {
    if (!('businessPlatformId' in value) || value['businessPlatformId'] === undefined) return false;
    if (!('externalAccountId' in value) || value['externalAccountId'] === undefined) return false;
    if (!('credentialKey' in value) || value['credentialKey'] === undefined) return false;
    if (!('credentialSecret' in value) || value['credentialSecret'] === undefined) return false;
    return true;
}

export function TestReq1FromJSON(json: any): TestReq1 {
    return TestReq1FromJSONTyped(json, false);
}

export function TestReq1FromJSONTyped(json: any, ignoreDiscriminator: boolean): TestReq1 {
    if (json == null) {
        return json;
    }
    return {
        
        'businessPlatformId': json['businessPlatformId'],
        'externalAccountId': json['externalAccountId'],
        'credentialKey': json['credentialKey'],
        'credentialSecret': json['credentialSecret'],
    };
}

export function TestReq1ToJSON(json: any): TestReq1 {
    return TestReq1ToJSONTyped(json, false);
}

export function TestReq1ToJSONTyped(value?: TestReq1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessPlatformId': value['businessPlatformId'],
        'externalAccountId': value['externalAccountId'],
        'credentialKey': value['credentialKey'],
        'credentialSecret': value['credentialSecret'],
    };
}

